import { getLocale } from 'utils';
import { KK_MONTHS } from 'common/constants';
import { FaqVariablesInput } from '../types';

export const computeFaqVariables = ({
  imagesCount,
  breadcrumbs,
  productId,
  price,
  lang,
  displayedName,
}: FaqVariablesInput) => {
  const breadcrumbThirdLevel = breadcrumbs?.[breadcrumbs.length > 0 ? breadcrumbs.length - 1 : 0];
  const parentLink = breadcrumbThirdLevel?.link || '';
  const parentLinkText = breadcrumbThirdLevel?.label || '';

  const locale = getLocale(lang);
  const currentDate = new Date();

  const getMonthName = () => {
    if (lang?.toLowerCase().startsWith('kk')) {
      return KK_MONTHS[currentDate.getMonth()];
    }

    return new Intl.DateTimeFormat(lang, { month: 'long' }).format(currentDate);
  };

  const fullDate = new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(currentDate);

  const pad = (n: number) => String(n).padStart(2, '0');
  const dateIso = `${currentDate.getFullYear()}-${pad(currentDate.getMonth() + 1)}-${pad(currentDate.getDate())}`;

  return {
    number_of_product_photos: imagesCount,
    parent_link: parentLink,
    parent_link_text: parentLinkText,
    price: price?.main_price || 0,
    LMCode: productId || '',
    month: getMonthName().toLowerCase(),
    year: currentDate.getFullYear(),
    date: fullDate,
    date_iso: dateIso,
    displayedName: displayedName || '',
  };
};
